import { List } from 'immutable'; // Note: these must match translation keys under ecosystemMarketplaceCore.reviews.responses

export const TITLE = 'TITLE';
export const REVIEW = 'REVIEW';
export const FOR = 'FOR';
export const PROS = 'PROS';
export const CONS = 'CONS';
export const CUSTOMIZABLE = 'CUSTOMIZABLE'; // Asset marketplace only

export const SERVICES = 'SERVICES'; // Solutions marketplace only

export const QuestionOrder = List([TITLE, REVIEW, FOR, CUSTOMIZABLE, PROS, CONS, SERVICES]);